import { render, staticRenderFns } from "./edit-store-menu-item.vue?vue&type=template&id=516e0e9b&scoped=true&"
import script from "./edit-store-menu-item.vue?vue&type=script&lang=js&"
export * from "./edit-store-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516e0e9b",
  null
  
)

export default component.exports